import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

@Composable
fun StandingsScreen(token: String?, leagueId: String, leagueName: String) {
    var standings by remember { mutableStateOf<List<StandingsRowDto>>(emptyList()) }
    var cached by remember { mutableStateOf(false) }
    var loading by remember { mutableStateOf(true) }
    var error by remember { mutableStateOf<String?>(null) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(leagueId, refreshKey) {
        loading = true
        try {
            val resp = Api.fetchStandings(token, leagueId)
            standings = resp.standings
            cached = resp.cached
            error = null
        } catch (e: Throwable) {
            error = "Načtení tabulky selhalo: ${e.message}"
        }
        loading = false
    }

    Div(attrs = { classes("card") }) {
        H2 { Text("Tabulka ligy — $leagueName") }
        Button(attrs = { onClick { refreshKey++ } }) { Text("Obnovit") }
        Span { Text(if (cached) " (z cache)" else " (přepočteno)") }
        if (loading) Text("Načítám…")
        error?.let { Div { Text("Chyba: $it") } }

        Table {
            Tr {
                Th { Text("#") }
                Th { Text("Tým") }
                Th { Text("Z") }
                Th { Text("V") }
                Th { Text("R") }
                Th { Text("P") }
                Th { Text("K") }
                Th { Text("Body") }
                Th { Text("Průměr") }
                Th { Text("Tie-break") }
            }
            standings.forEach { row ->
                val avg = if (row.gamesPlayed > 0) row.totalScoreFor.toDouble() / row.gamesPlayed else 0.0
                Tr {
                    Td { Text(row.rank.toString()) }
                    Td { Text(row.teamName) }
                    Td { Text(row.played.toString()) }
                    Td { Text(row.wins.toString()) }
                    Td { Text(row.draws.toString()) }
                    Td { Text(row.losses.toString()) }
                    Td { Text(row.forfeitLosses.toString()) }
                    Td { Text(row.points.toString()) }
                    Td { Text(formatAvg(avg)) }
                    Td { Text(row.tieBreakChip ?: "") }
                }
            }
        }
    }
}
